var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.collection
    ? _c("div", { staticClass: "w-100 h-100 overflow-y-auto" }, [
        _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
          _c(
            "ol",
            {
              staticClass: "breadcrumb",
              style: { "background-color": _vm.breadCrumbColor }
            },
            [
              _c("li", {
                staticClass: "breadcrumb-item",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.detectDangerousTags(_vm.collection.name)
                  )
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "p-2 w-100 row no-gutters" },
          _vm._l(_vm.collection.links, function(link) {
            return _c(
              "div",
              {
                staticClass:
                  "col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 pr-2 pb-2",
                staticStyle: { height: "7rem" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary h-100 w-100",
                    style: {
                      "background-color": _vm.buttonColor,
                      "border-color": _vm.buttonColor
                    },
                    attrs: {
                      href: link.url,
                      target: link.newTab ? "_blank" : "_self"
                    }
                  },
                  [
                    _c("CenterOnParent", [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.detectDangerousTags(link.name))
                        }
                      })
                    ])
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }